// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aba2ea21","547":"832d7bbf","862":"72def679"}[chunkId] + ".chunk.js";
};